import styled from 'styled-components';
import { Text, Box } from '@rsos/components/capstone/base';

export const Description = styled(Text).attrs({
  size: 'normal',
  fontWeight: 'bold',
  color: 'primaryText',
})``;

export const Container = styled(Box).attrs({
  width: '100%',
  p: 20,
  borderRadius: '5px',
  position: 'relative',
})`
  border: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  min-height: ${({ fetching }) => (fetching ? '250px' : 'auto')};
`;
export const UploadInputContainer = styled.input`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
`;
